var _excluded = ["options", "isDisabled", "isLoading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { noop } from 'lodash';
import { useState } from 'react';
import { ActionsDropdownMenu } from '../../../containers/ActionsDropdownMenu';
import { Icon } from '../../../foundations';
import { forwardRef } from '../../../utils';
import { _TableCell as TableCell } from '../_TableCell';
/**
 * @private Please use `TableAmountCellProps` from `@melio/penny`.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention

import { jsx as _jsx } from "react/jsx-runtime";

/**
 * @private Please use `Table.ActionsCell` from `@melio/penny`.
 */
export var _TableActionsCell = forwardRef((_ref, ref) => {
  var _props$dataTestid;

  var {
    options,
    isDisabled = false,
    isLoading
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [isMenuOpen, setIsMenuOpen] = useState(false);
  var dropdownActionsTestId = "".concat((_props$dataTestid = props['data-testid']) !== null && _props$dataTestid !== void 0 ? _props$dataTestid : 'table-actions-cell', "-dropdown-actions");

  var tableActionsTrigger = /*#__PURE__*/_jsx(TableCell // TODO: remove empty onClick. It must be passed in order for the hover background color to show.
  // ticket - ME-452 - https://meliorisk.atlassian.net/browse/ME-452
  , _objectSpread(_objectSpread({
    onClick: !isDisabled ? noop : undefined,
    "data-component": "_TableActionsCell",
    "data-testid": "table-actions-cell",
    ref: ref,
    "aria-label": "table-actions-trigger"
  }, props), {}, {
    textAlign: "center",
    color: "neutral.darker",
    children: /*#__PURE__*/_jsx(Icon, {
      isDisabled: isDisabled,
      type: "more-vertical",
      "aria-hidden": true // The icon's aria-label shouldn't be announced by screen readers
      ,
      "data-testid": "table-actions-cell-button",
      size: "small",
      color: "inherit"
    })
  }));

  return !isLoading ? /*#__PURE__*/_jsx(ActionsDropdownMenu, {
    isOpen: isMenuOpen,
    onOpenChange: setIsMenuOpen,
    trigger: tableActionsTrigger,
    isDisabled: isDisabled,
    "test-id": dropdownActionsTestId,
    items: options
  }) : /*#__PURE__*/_jsx(TableCell, {
    ref: ref
  }) // we need this empty cell for the Blanket to be positioned properly when isLoading
  ;
});
_TableActionsCell.displayName = '_TableActionsCell';
//# sourceMappingURL=_TableActionsCell.js.map